import validator from 'validator';
import i18n from "shared/i18n";

const validate = (values, {me}) => {
  const errors = {};

  if (!values.password) {
    errors.password = i18n.t("Password is required");
  }

  if (!values.email) {
    errors.email = i18n.t("Email should not be blank");
  } 
  
  if (values.email === me.email) {
    errors.email = i18n.t("This is your current email");
  }

  if (!values.email2) {
    errors.email2 = i18n.t("Сonfirmation email should not be blank");
  }

  if (values.email && !validator.isEmail(values.email)) {
    errors.email = i18n.t("Please enter a valid Email");
  }

  if (values.email && values.email2 && values.email !== values.email2) {
    errors.email2 = i18n.t("Your email confirmation does not match");
  }

  return errors;
};
validate.defaultPops = {
  me: null,
}

export default validate;

